import { addItemToCollection } from "directus/src/operations";

// Add createProject function
export async function createOpening({ item }) {
    try {
        const query = {
            fields: [
                "id",
                "title",
                "description",
                "status",
                "expertise",
                "opportunity_link",
                "sales_coordinator",
                "skills"
            ],
        };

        const data = await addItemToCollection("openings", item, query);

        return data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}
